/* eslint-disable */ //
/**
 * File contains all constants used thoroughout the app.
 * Note: Constants that are plural are dictionaries (key-value pairs).
 */

import config from 'config';

export const CURRENT_YEAR = new Date().getFullYear();
export const CLOUD_ENV = 'cloudEnv';
export const AUTH0_PREFIX = '@@auth0spajs@@';
export const PROVIDERS = 'providers';

export const HELP_URL = 'https://textrecruit.zendesk.com/hc/en-us';
export const HELP_CENTER_URL = 'https://community.icims.com/login';

export const cacheKey = {
	TOKEN: 'token',
	SEND_METHOD: 'sendMethod'
};

export const authMethods = {
	LEGACY: 'legacy',
	SSO: 'sso',
	IAM: 'iam'
};

export const cloudEnvs = {
	GOV: 'awsgov',
	EU: 'awseu-prd',
	AZURE: 'azure'
};

export const messageTypes = {
	INBOUND: 0,
	OUTBOUND: 1
};

export const channelTypes = {
	ALL: 'ALL',
	SMS: 'Sms',
	WHATS_APP: 'WhatsApp',
	FACEBOOK: 'Facebook',
	FACEBOOK_MESSENGER: 'FacebookMessenger',
	JOB_CHAT: 'JobChat'
};

export const candidateStatusTypes = {
	ACTIVE: 'active',
	INACTIVE: 'inactive',
	DELETED: 'deleted',
	STARRED: 'Starred',
	ARCHIVE: 'archive',
	UNARCHIVE: 'unarchive'
};

/**
 * 4 hours (in milliseconds)
 * @type {{REFRESH_TOKEN_INTERVAL: Number}}
 */
export const REFRESH_TOKEN_INTERVAL = 4 * 3600 * 1e3;

export const WEB_URLS = {
	FORGOT_PW: `${config.webAppUrl}/#/forgotpw`,
	EU_FORGOT_PW: 'https://eu.textrecruit.com/#/forgotpw',
	PRIVACY: 'https://www.textrecruit.com/privacy/',
	TERMS: 'https://www.textrecruit.com/terms-and-conditions/',
	TR_DEMO_REQUEST: 'https://info.textrecruit.com/textrecruit-demo-request'
};

export const IMG_URIS = {
	COUNTRY_FLAGS: `${config.imageBaseUrl}/flags`,
	SMALL_LOGO: `${config.imageBaseUrl}/small-logo-text.png`,
	YOU_THUMBNAIL: `${config.imageBaseUrl}/you-64.png`,
	ICIMS_LOGO: `${config.imageBaseUrl}/product-logos/icims_logo_header_black_teal.svg`,
	ICIMS_LOGO_NEW: `${config.imageBaseUrl}/product-logos/icims_full_color_logo_purple.svg`
};

export const resource = {
	ADD_CANDIDATE_API: 'candidate/add?',
	GET_CANDIDATE_BY_PHONE: 'candidate_by_phone?',
	CANDIDATES: 'candidates?',
	GET_CANDIDATE_BY_ID: 'candidate?',
	GET_CANDIDATE_BY_SOURCE: 'candidate_by_source?',
	ADD_CANDIDATE_TO_CAMPAIGN: 'candidates/add_job?',
	AUTH_API: 'user/authenticate?',
	CAMPAIGN_API: 'job?',
	CAMPAIGNS_API: 'jobs?',
	ADD_CAMPAIGN: 'job/add?',
	GET_MESSAGES_API: 'messages/related?',
	REMOVE_CANDIDATE_FROM_CAMPAIGN: 'candidate/remove_job?',
	MESSAGE_TEMPLATES: 'templates?',
	SEND_MESSAGE: 'message/send_single?',
	TOKEN_INFO: 'user/token_info?',
	REFRESH_TOKEN: 'user/authenticate_uid?',
	GET_BASIC_USER: 'customer/basic?',
	VALIDATE_PHONE_NUMBER: 'number/validate?',
	INTEGRATION_DATA: 'integration_data?',
	MESSAGE_THREADS: 'threads?',
	MESSAGE: 'message?',
	TRACK_SESSION: 'track/session',
	TRACK_ACTIVE: 'track/active'
};

export const errorCodes = {
	UNAUTHENTICATED: { code: 1001, message: 'Bad Username/Password' }
};

export const postBodyEndpoints = new Set([
	resource.GET_MESSAGES_API,
	resource.GET_CANDIDATE_BY_ID,
	resource.TOKEN_INFO,
	resource.CANDIDATES,
	resource.SEND_MESSAGE,
	resource.TRACK_ACTIVE,
	resource.TRACK_SESSION
]);

export const loadTime = 250;
export const pageLength = 4;
export const maxCandidates = 100;
export const debounceWait = 800;
export const hrsDay = 24;
export const millisecondsHr = 3600 * 1e3;

export const countryToCodeMapping = {
	// eslint-disable-next-line camelcase
	united_states: 'US',
	canada: 'CA',
	// eslint-disable-next-line camelcase
	united_kingdom: 'GB',
	germany: 'DE',
	france: 'FR',
	philippines: 'PH',
	australia: 'AU',
	austria: 'AT',
	israel: 'IL',
	netherlands: 'NL'
};

export const codeToCountryMapping = {
	US: 'united_states',
	CA: 'canada',
	GB: 'united_kingdom',
	DE: 'germany',
	FR: 'france',
	PH: 'philippines',
	AU: 'australia',
	AT: 'austria',
	IL: 'israel',
	NL: 'netherlands'
};

export const extendedTimeZones = [
	{ value: 'America/Anchorage', name: 'Anchorage (Alaska)' },
	{ value: 'Pacific/Honolulu', name: 'Honolulu (Hawaii)' },
	{ value: 'Europe/London', name: 'London (UK)' },
	{ value: 'Asia/Manila', name: 'Philippines' },
	{ value: 'America/St_Johns', name: 'Newfoundland Time' },
	{ value: 'America/Halifax', name: 'Atlantic Time' },
	{ value: 'America/Blanc-Sablon', name: 'Atlantic Standard Time' },
	{ value: 'Australia/Hobart', name: 'Australia (Tasmania)' },
	{ value: 'Australia/Melbourne', name: 'Australia (Melbourne)' },
	{ value: 'Australia/Sydney', name: 'Australia (New South Wales)' },
	{ value: 'Australia/Brisbane', name: 'Australia (Queensland)' },
	{ value: 'Australia/Adelaide', name: 'Australia (Southern)' },
	{ value: 'Australia/Darwin', name: 'Australia (Northern)' },
	{ value: 'Australia/Perth', name: 'Australia (Western)' },
	{ value: 'Europe/Lisbon', name: 'Western European Time' },
	{ value: 'Europe/Paris', name: 'Central European Time' },
	{ value: 'Europe/Sofia', name: 'Eastern European Time' },
	{ value: 'Etc/Greenwich', name: 'Greenwich Mean Time' },
	{ value: 'Europe/Moscow', name: 'Moscow Standard Time' },
	{ value: 'Africa/Lagos', name: 'Western African Time ' },
	{ value: 'Africa/Maputo', name: 'Central Aftrican Time' },
	{ value: 'Africa/Cairo', name: 'Eastern African Time' },
	{ value: 'Africa/Maputo', name: 'South Africa Standard Time' },
	{ value: 'Europe/Moscow', name: 'Eastern European Standard Time ' },
	{ value: 'Asia/Riyadh', name: 'Arabian Standard Time' },
	{ value: 'Asia/Tehran', name: 'Iran Standard Time' },
	{ value: 'Asia/Jerusalem', name: 'Israel Standard Time' },
	{ value: 'Asia/Muscat', name: 'Gulf Standard Time' }
];

export const timeZones = [
	{ value: 'America/Los_Angeles', name: 'Los Angeles (Pacific)' },
	{ value: 'America/Denver', name: 'Denver (Mountain)' },
	{ value: 'America/Phoenix', name: 'Phoenix (MST)' },
	{ value: 'America/Chicago', name: 'Chicago (Central)' },
	{ value: 'America/New_York', name: 'New York (Eastern)' }
];

export const pendoTypes = {
	candidateChannelChanged: 'Candidate Channel Changed',
	candidateSearch: 'Candidate Search',
	highlightToggled: 'Highlight Toggled',
	blacklistWebsite: 'Blacklist Website',
	reincludeBlacklistedWebsite: 'Reinclude Blacklisted Website',
	trackPhoneNumberPreference: 'Track Phone Number Preference'
};

export const apps = {
	BROWSER_EXTENSION: 'Browser Extension'
};

export const pendoProductAreas = {
	TEXT_ENGAGEMENT: 'Text Engagement'
};

export const headerConstants = {
	LOGO_HEIGHT: 20,
	LOGO_HEIGHT_OLD: 30
};
